const auxiliary = (props) => props.children;

export default auxiliary;


// WEBPACK FOOTER //
// ./src/Hoc/Auxiliary/Auxiliary.js